export const aboutIntro = {
  title: '关于吃瓜网',
  subtitle: '全网最火的在线吃瓜平台',
  description: '吃瓜网官网创立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的网络爆料内容。从网红塌房到明星黑料，从博主反差到每日热点，吃瓜网始终站在网络事件的第一线，为读者带来深度、有趣的吃瓜体验。',
  mission: '我们的使命是让每一位吃瓜群众都能第一时间获取最真实的网络热点信息，不错过任何一个值得关注的网络事件。',
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20newsroom%20with%20multiple%20screens%20displaying%20social%20media%20feeds%2C%20warm%20ambient%20lighting%2C%20editorial%20office%20environment%2C%20professional%20yet%20casual%20atmosphere%2C%20digital%20media%20company%20concept%2C%20clean%20modern%20interior%2C%20soft%20shadows&width=800&height=600&seq=about-brand-image&orientation=landscape',
};

export const platformStats = [
  {
    label: '每日更新',
    value: '24h',
    description: '全天候实时追踪网络热点，确保读者第一时间获取最新爆料信息。',
    icon: 'ri-time-line',
  },
  {
    label: '累计爆料',
    value: '3,200+',
    description: '自创立以来累计发布超过3200篇深度爆料文章，涵盖各大领域。',
    icon: 'ri-file-text-line',
  },
  {
    label: '活跃读者',
    value: '500K+',
    description: '日活跃用户超过50万，月活跃用户突破200万，覆盖全国。',
    icon: 'ri-user-smile-line',
  },
];

export const contactInfo = {
  email: 'hello@my783e.cn',
  wechat: 'chiguawang_official',
  weibo: '@吃瓜网官微',
  address: '北京市朝阳区网络文化产业园A座',
  phone: '010-8888-6666',
  businessHours: '周一至周五 9:00-18:00',
};

export const faqItems = [
  {
    question: '吃瓜网官网的内容来源是什么？',
    answer: '吃瓜网官网的内容来自专业编辑团队的搜集整理，以及广大网友的投稿爆料。我们的编辑团队会对每条信息进行多方核实，确保内容的真实性和准确性。',
  },
  {
    question: '如何在吃瓜网官网投稿爆料？',
    answer: '您可以通过发送邮件至 hello@my783e.cn 进行投稿，或者在社交平台私信我们的官方账号。投稿时请附上相关证据材料，我们的编辑会在24小时内审核回复。',
  },
  {
    question: '吃瓜网官网是否接受商务合作？',
    answer: '是的，我们接受品牌推广和商务合作。请通过邮箱 hello@my783e.cn 或添加官方微信 chiguawang_official 与我们联系，商务团队会在2个工作日内回复。',
  },
  {
    question: '如果涉及不实信息，如何申请删除？',
    answer: '如您认为平台上的某些内容涉及不实信息或侵犯了您的合法权益，请发送删除申请至 hello@my783e.cn，我们的法务团队会在收到申请后的48小时内进行处理。',
  },
];